import { Link } from "react-router-dom";
import { FACES, type FaceId } from "~/lib/faces";

interface MobileFaceStripProps {
  activeId: FaceId | null;
}

/**
 * Horizontal-scroll chip strip of all eight cubies. Visible only on small
 * screens (the desktop chrome nav covers md+). Lets phone visitors jump
 * between cubies without going back to the cube.
 */
export function MobileFaceStrip({ activeId }: MobileFaceStripProps) {
  return (
    <nav
      aria-label="Cubies"
      className="sticky top-14 z-30 border-b border-jg-border/40 bg-jg-bg/80 backdrop-blur-md md:hidden"
    >
      <ul className="-mx-1 flex gap-1.5 overflow-x-auto px-3 py-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {FACES.map((f) => {
          const active = activeId === f.id;
          return (
            <li key={f.id} className="shrink-0">
              <Link
                to={f.route}
                aria-current={active ? "page" : undefined}
                className={[
                  "block rounded-full border px-3 py-1 text-xs font-medium whitespace-nowrap transition-colors",
                  active
                    ? ""
                    : "border-jg-border bg-jg-bg-soft/40 text-jg-fg-muted hover:text-jg-fg",
                ].join(" ")}
                style={
                  active
                    ? {
                        color: f.themeColor,
                        borderColor: `${f.themeColor}66`,
                        backgroundColor: `${f.themeColor}1a`,
                      }
                    : undefined
                }
              >
                {f.shortLabel}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
